import { useState } from 'react';
import { PlaybackStatus, usePlayerContext } from '../../../../contexts/PlayerContext';
import { AnalyticsEventType } from '../../../../hooks/analytics/analytics.types';
import useAnalytics from '../../../../hooks/analytics/useAnalytics';
import { Logger } from '../../../../utils/logger';
import { TracklistAction, TracklistActionType } from './tracklist.types';
import classes from './Tracklist.module.css';
import TracklistItem from './TracklistItem/TracklistItem';
import NotesIcon from '../../../../elements/icons/NotesIcon';

const logger = new Logger('Tracklist');

// implement groups? -> The biggest work/issue is probably the angular ui
// implement download all => They should been zipped? With or without npm package?

type TracklistProps = {
  notesEnabled: boolean;
  spotifyEnabled: boolean;
  enableExpandAll?: boolean;
};

function Tracklist({ notesEnabled, spotifyEnabled, enableExpandAll }: TracklistProps): JSX.Element {
  const playerContext = usePlayerContext();
  const { trackAnalyticsEvent } = useAnalytics();
  const [showAllDetails, setShowAllDetails] = useState(false);
  const tracks = playerContext.tracklist?.tracks;
  const tracksHaveNotes = tracks?.some((track) => track.notes);

  const handleUserInteraction = (action: TracklistAction) => {
    switch (action.type) {
      case TracklistActionType.PLAY:
        playerContext.play();
        break;
      case TracklistActionType.PAUSE:
        playerContext.pause();
        break;
      case TracklistActionType.GO_TO_TRACK:
        playerContext.tracklist?.goTo(action.index);
        break;
      case TracklistActionType.SHOW_ALL_TRACKS_NOTES:
        setShowAllDetails(!showAllDetails);
        if (!showAllDetails) trackAnalyticsEvent({ type: AnalyticsEventType.SHOW_NOTES });
        break;
      case TracklistActionType.SHOW_NOTES:
        trackAnalyticsEvent({ type: AnalyticsEventType.SHOW_NOTES, track_id: action.trackId });
        break;
      case TracklistActionType.LINK_TO_SPOTIFY:
        trackAnalyticsEvent({ type: AnalyticsEventType.LINK_TO_SPOTIFY, track_id: action.trackId });
        break;
      default:
        logger.warn('Unhandled tracklist action:', action);
    }
  };

  return (
    <article className={classes.trackListContainer}>
      {notesEnabled && tracksHaveNotes && enableExpandAll && (
        <div className={classes.tracklistOptionsContainer}>
          <button type="button" className={classes.tracklistOptions} onClick={() => handleUserInteraction({ type: TracklistActionType.SHOW_ALL_TRACKS_NOTES })}>
            <p>{showAllDetails ? 'collapse all notes' : 'expand all notes'}</p>
            <NotesIcon />
          </button>
        </div>
      )}
      <section className={classes.tracklist}>
        {!!tracks?.length && tracks.map((track, index) => (
          <TracklistItem
            key={track.id}
            notesEnabled={notesEnabled}
            spotifyEnabled={spotifyEnabled}
            handleUserInteraction={handleUserInteraction}
            track={track}
            index={index}
            isCurrentTrack={playerContext.tracklist?.index === index}
            showAllDetails={showAllDetails}
            isPlaying={playerContext.playbackStatus === PlaybackStatus.PLAYING}
          />
        ))}
        {!tracks?.length && <p>No tracks provided.</p>}
      </section>
    </article>
  );
}

export default Tracklist;
